import PropTypes from 'prop-types'
import { DatePicker } from 'baseui/datepicker'
import useSDDatePicker from './useSDDatePicker'

const SDDatePicker = ({ overrides, ...rest }) => {
  const { datePickerOverrides } = useSDDatePicker(overrides)

  return <DatePicker {...rest} overrides={datePickerOverrides} />
}

SDDatePicker.propTypes = {
  overrides: PropTypes.object,
}

export default SDDatePicker
